import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { login, logout } from '@/api/auth'
import { permissionsFor } from '@/config/permissions'
import type { LoginPayload, SessionUser } from '@/types/auth'
import { clearSession, readSession, writeSession } from '@/utils/storage'

export const useAuthStore = defineStore('auth', () => {
  const session = readSession()
  // 权限由商家类型决定，刷新时重新计算，避免旧缓存缺少新增菜单权限。
  const user = ref<SessionUser | null>(
    session ? { ...session, permissions: permissionsFor(session.productType) } : null,
  )
  const isAuthenticated = computed(() => Boolean(user.value?.token))

  function hasPermission(permission?: string): boolean {
    return !permission || Boolean(user.value?.permissions.includes(permission))
  }

  async function signIn(payload: LoginPayload): Promise<void> {
    const result = await login(payload)
    const session: SessionUser = {
      token: result.token,
      name: result.name || payload.username,
      productType: result.productType,
      permissions: permissionsFor(result.productType),
    }
    if (!session.permissions.length) throw new Error('当前商家类型尚未配置权限')
    user.value = session
    writeSession(session)
  }

  function clear(): void {
    user.value = null
    clearSession()
  }

  async function signOut(): Promise<void> {
    try {
      await logout()
    } finally {
      clear()
    }
  }

  return { user, isAuthenticated, hasPermission, signIn, signOut, clear }
})
